<div class="p-t-30">
  <div class="page-layout blank" style="min-height: inherit">
    <form (keydown.enter)="$event.preventDefault()" [formGroup]="addMappingForm"
          class="orbitax-form-container flex flex-col flex-1-0-auto ">
      <div class="p-l-30 p-r-30 scrollable-area simple-scroll flex flex-col full-grow-no-shrink-no-basis">

        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="flex-1-1-50" requi>
            <mat-label>Destination Company</mat-label>
            <mat-select formControlName="destinationCompany">
              <mat-option *ngFor="let company of companies"
                          [value]="company?.companyId">{{company.companyName + '_' + company.companyId}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex flex-col" *ngIf="makeVisibleRest">

          <div class="flex flex-row justify-start items-start auto-flex">
            <mat-form-field appearance="outline" class="flex-1-1-50" requi>
              <mat-label>Mapped Companies</mat-label>
              <textarea matInput formControlName="mappedCompanies" (click)="onClickMappedCompanies()"
                        [value]="mapCompaniesString">
              </textarea>
            </mat-form-field>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>
